import { useMemo } from 'react';
import { useClientNavigationPathname } from '@alltrails/core/hooks/useClientNavigation';

/**
 * Hook to determine if parks should be fetched based on the current pathname.
 *
 *
 * Parks should not be fetched on custom-routes or poi pages.
 */
const useShouldFetchParks = (): boolean => {
  const pathname = useClientNavigationPathname();

  return useMemo(() => {
    if (!pathname) {
      return true; // Default to fetching if pathname isn't available
    }
    return !pathname.includes('/custom-routes') && !pathname.includes('/poi');
  }, [pathname]);
};

export default useShouldFetchParks;
